import { ToastData } from '../../../../../components/blackrock/advisor-center/toast/model';
import { MAIN_NAV_TOASTER_CREATE_EVENT } from '../components/header-toaster/config';
import { toasterId } from '../components/header-toaster/MainNavToaster';
import { useEffect } from 'react';

export const createMainNavToast = (toastData: ToastData) => {
	let toasterWindow = window as Window;
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	if (window.top.document.getElementById(toasterId)) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		toasterWindow = window.top;
	} else if (window.parent.document.getElementById(toasterId)) {
		toasterWindow = window.parent;
	}

	toasterWindow.dispatchEvent(
		new CustomEvent(MAIN_NAV_TOASTER_CREATE_EVENT, {
			detail: toastData,
		}) as CustomEvent<ToastData>
	);
};

export const HIDE_TOASTER_EVENT = 'hide-toaster';

export const useEventListenerToResetToaster = (resetToaster: () => void) => {
	useEffect(() => {
		const onMessage = (event: MessageEvent) => {
			if (event.data?.type === HIDE_TOASTER_EVENT) {
				resetToaster();
			}
		};

		window.addEventListener('message', onMessage);

		return () => {
			window.removeEventListener('message', onMessage);
		};
	}, []);
};
